import {
  ActivityListItem,
  GetDetailsForLeaseResponse,
  GetPaginatedOccupiedUnitDataForLocationRequestParams,
  GetPaginatedOccupiedUnitDataForLocationResponse,
  GetPolicyDetailsForLeaseResponse,
  GetPrivateInsuranceDetailsForLeaseResponse,
} from "@safelease/service-utilities";
import http from "./http-common";

class PrivatePolicyComplianceConfigService {
  getPaginatedOccupiedUnitDataForLocation(locationId: string, params: GetPaginatedOccupiedUnitDataForLocationRequestParams) {
    return http.get<GetPaginatedOccupiedUnitDataForLocationResponse>(`leases/occupied-unit-data/locations/${locationId}`, { params });
  }

  getDetailsForLease(leaseId: string) {
    return http.get<GetDetailsForLeaseResponse>(`leases/details/${leaseId}`);
  }

  getPolicyDetailsForLease(leaseId: string) {
    return http.get<GetPolicyDetailsForLeaseResponse>(`leases/policy-details/${leaseId}`);
  }

  getPrivateInsuranceDetailsForLease(leaseId: string) {
    return http.get<GetPrivateInsuranceDetailsForLeaseResponse>(`leases/private-insurance-details/${leaseId}`);
  }

  getActivityListForLease(leaseId: string) {
    return http.get<ActivityListItem[]>(`leases/activity-list/${leaseId}`);
  }
}

export default new PrivatePolicyComplianceConfigService();
